__turbopack_context__.v({
  "className": "dm_sans_de0e14ad-module__WvMOaW__className",
  "variable": "dm_sans_de0e14ad-module__WvMOaW__variable",
});
